import { useId } from 'react';
import styled from 'styled-components';

export const CANCELLATION_REASON_PRESETS = ['수량 부족', '상품 불량', '판매 중단'];

export default function CancellationReasonField({ value, onChange, disabled = false }: {
  value: string; onChange: (reason: string) => void; disabled?: boolean;
}) {
  const id = useId();
  return <Field>
    <label htmlFor={id}>관리자 취소 사유 <span>필수</span></label>
    <Presets role="group" aria-label="취소 사유 빠른 선택">
      {CANCELLATION_REASON_PRESETS.map(reason => <button key={reason} type="button" disabled={disabled}
        aria-pressed={value === reason} onClick={() => onChange(reason)}>{reason}</button>)}
    </Presets>
    <textarea id={id} required maxLength={500} rows={3} value={value} disabled={disabled}
      placeholder="사유를 선택하거나 직접 입력해주세요." onChange={event => onChange(event.target.value)}
      aria-describedby={`${id}-help`} />
    <small id={`${id}-help`}>구매자 정산서에 표시됩니다.</small>
  </Field>;
}

const Field = styled.div`
  display: grid; gap: var(--space-2); min-width: 0; text-align: left;
  label { color: var(--color-text-primary); font-size: var(--text-body); font-weight: 600; }
  label span { margin-left: var(--space-1); color: var(--color-text-danger); font-size: var(--text-caption); }
  textarea { box-sizing: border-box; width: 100%; min-width: 0; resize: vertical;
    padding: var(--space-2) var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
    background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; }
  textarea::placeholder { color: var(--color-text-disabled); }
  textarea:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  textarea:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); }
  small { color: var(--color-text-secondary); font-size: var(--text-caption); }
`;
const Presets = styled.div`
  display: flex; flex-wrap: wrap; gap: var(--space-2);
  button { min-height: var(--control-sm); padding: 0 var(--space-3); border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; cursor: pointer; }
  button[aria-pressed="true"] { border-color: var(--color-brand); background: var(--color-brand-subtle); color: var(--color-text-link); }
  button:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  button:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: default; }
  @media (pointer: coarse) { button { min-height: var(--touch-target); } }
`;
